// Dynamic Diesels — Cart page.
// Quantity/remove update via /cart/change.js and re-render this section
// (Section Rendering API). Note saves on blur. Checkout button submits to checkout.

(function () {
  'use strict';

  function init() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    const sectionId = page.getAttribute('data-section-id');

    function setBusy(on) { page.classList.toggle('is-loading', on); }

    function reRender(html) {
      if (!html) { window.location.reload(); return; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newPage = doc.querySelector('[data-cart-page]');
      if (newPage) {
        page.innerHTML = newPage.innerHTML;
      }
      // Sync header cart bubbles across the site.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => {
          document.querySelectorAll('[data-cart-bubble]').forEach((b) => {
            b.textContent = c.item_count > 0 ? '(' + c.item_count + ')' : '';
          });
        })
        .catch(() => {});
    }

    async function changeLine(line, quantity) {
      setBusy(true);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId }),
        });
        const data = await res.json();
        reRender(data.sections && data.sections[sectionId]);
      } catch (e) { window.location.reload(); }
      setBusy(false);
    }

    // Delegated clicks: qty +/-, remove, checkout
    page.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-checkout]')) {
        window.location.href = '/checkout';
        return;
      }
      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const line = parseInt(item.getAttribute('data-line'), 10);
      const input = item.querySelector('[data-cart-qty]');
      const current = parseInt(input ? input.value : '1', 10) || 1;
      if (e.target.closest('[data-cart-remove]')) { changeLine(line, 0); }
      else if (e.target.closest('[data-cart-plus]')) { changeLine(line, current + 1); }
      else if (e.target.closest('[data-cart-minus]')) { changeLine(line, Math.max(0, current - 1)); }
    });

    // Manual quantity edit
    page.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      const item = input.closest('[data-cart-item]');
      const line = parseInt(item.getAttribute('data-line'), 10);
      changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
    });

    // Save order note on blur
    page.addEventListener('blur', (e) => {
      const note = e.target.closest('[data-cart-note]');
      if (!note) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value }),
      }).catch(() => {});
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
